export const getFinaleRound = (finale, indexOverride = null) => {
    if (!finale || !Array.isArray(finale.rounds)) return null;
    const index = Number.isInteger(indexOverride) ? indexOverride : finale.roundIndex;
    if (!Number.isInteger(index)) return null;
    return finale.rounds[index] || null;
};

export const totalSelectableChars = (phrase = '') => {
    if (!phrase) return 0;
    return Array.from(phrase).filter((char) => /[\p{L}\p{N}]/u.test(char)).length;
};

export const normalizeFinaleState = (finale) => {
    if (!finale || !Array.isArray(finale.rounds)) return finale;
    const rounds = finale.rounds.map((round) => {
        if (!round || round.phrase != null) return round;
        return { ...round, phrase: '' };
    });
    return { ...finale, rounds };
};
